module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 per page")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-flex"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isPaginated),
      callback: function($$v) {
        _vm.isPaginated = $$v
      },
      expression: "isPaginated"
    }
  }, [_vm._v("Paginated")])], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.userData,
      "paginated": _vm.isPaginated,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "pagination-simple": _vm.isPaginationSimple,
      "default-sort-direction": 'asc',
      "default-sort": "firstName"
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "firstName",
            "label": "First Name",
            "sortable": ""
          }
        }, [_vm._v("\n                  " + _vm._s(props.row.firstName) + "\n              ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "lastName",
            "label": "Last Name",
            "sortable": ""
          }
        }, [_vm._v("\n                  " + _vm._s(props.row.lastName) + "\n              ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "createdAt",
            "label": "Created",
            "sortable": ""
          }
        }, [_vm._v("\n                  " + _vm._s(props.row.createdAt) + "\n              ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "email",
            "label": "Email",
            "sortable": ""
          }
        }, [_c('a', {
          attrs: {
            "href": 'mailto:' + props.row.email
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.email) + "\n                  ")])]), _vm._v(" "), _c('b-table-column', [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDeleteAccount(props.row.id, props.row.displayName)
            }
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": "cancel",
            "custom-class": "button-danger"
          }
        })], 1)])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63069bf6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client_portal/manage_users/DeleteUserTab.vue
// module id = 514
// module chunks = 1